import React from "react";
import { TaxiServiceName, TaxiServiceEmail } from "../utils/languageMap";

export default function DriverPrivacyPolicy() {
  return (
    <div
      className="max-w-4xl mx-auto p-6 sm:p-10 bg-white rounded-2xl shadow-md"
      style={{ marginLeft: 50, marginRight: 50, marginBottom: 50 }}
    >
      <header className="mb-6">
        <h1 className="text-3xl sm:text-4xl font-semibold">Privacy Policy</h1>
        <p className="text-sm text-gray-500 mt-1">Effective date: January 25, 2021</p>
        <p className="mt-4 text-gray-700 whitespace-pre-line">
          {TaxiServiceName} ("us", "we", or "our") operates a mobile application
          (hereinafter referred to as the "Service").
          {"\n\n"}
          This page informs you of our policies regarding the collection, use,
          and disclosure of personal data when you use our Service and the
          choices you have associated with that data.
          {"\n\n"}
          We use your data to provide and improve the Service. By using the
          Service, you agree to the collection and use of information in
          accordance with this policy. Unless otherwise defined in this Privacy
          Policy, the terms used in this Privacy Policy have the same meanings
          as in our Terms and Conditions.
        </p>
      </header>

      <section className="space-y-6 text-gray-700 text-sm whitespace-pre-line">
        <div>
          <h2 className="text-lg font-medium">Information Collection And Use</h2>
          We collect several different types of information for various purposes
          to provide and improve our Service to you.
        </div>

        <div>
          <h2 className="text-lg font-medium">Types of Data Collected</h2>

          Personal Data
          {"\n"}
          While using our Service, we may ask you to provide us with certain
          personally identifiable information that can be used to contact or
          identify you ("Personal Data"). Personally identifiable information
          may include, but is not limited to:
          {"\n"}
          - First name and last name
          {"\n"}
          - Phone number
          {"\n"}
          - Cookies and Usage Data

          {"\n\n"}
          Automatically Collected Information
          {"\n"}
          In addition, the Application may collect certain information
          automatically, including, but not limited to:
          {"\n"}
          - the type of mobile device you use
          {"\n"}
          - your mobile device's unique device ID
          {"\n"}
          - the IP address of your mobile device
          {"\n"}
          - your mobile operating system
          {"\n"}
          - information about the way you use the Application

          {"\n\n"}
          Real Time Location Information
          {"\n"}
          When you use the mobile application, we may use GPS technology (or
          other similar technology) to:
          {"\n"}
          - send your exact location to the taxi service server where it is used
          to filter orders and show you only the appropriate data
          {"\n"}
          - enable the use of the in-app taximeter/taxi counter
          {"\n"}
          - enable the use of the in-app automatic idle time counter
        </div>

        <div>
          <h2 className="text-lg font-medium">Use of Data</h2>
          We use the collected data for various purposes:
          {"\n"}
          - To provide and maintain the Service
          {"\n"}
          - To notify you about changes to our Service
          {"\n"}
          - To allow you to participate in interactive features of our Service
          when you choose to do so
          {"\n"}
          - To provide customer care and support
          {"\n"}
          - To improve the Service
          {"\n"}
          - To monitor the usage of the Service
          {"\n"}
          - To detect, prevent and address technical issues
        </div>

        <div>
          <h2 className="text-lg font-medium">Data Retention</h2>

          We retain your Personal Data only for as long as necessary to provide
          the Service and fulfill the purposes described in this Privacy Policy.

          {"\n\n"}
          Driver account information, trip history, location records related to
          completed trips, and other operational data may be retained for as
          long as the driver continues cooperating with the taxi service. This
          information is required for dispatching, customer support,
          accounting, dispute resolution, fraud prevention, service
          improvement, and compliance with applicable legal obligations.

          {"\n\n"}
          When your cooperation with the taxi service ends, your personal data
          will be retained only for as long as necessary to comply with legal,
          regulatory, tax, accounting, or other legitimate business
          requirements. After that period, the data will be securely deleted or
          anonymized.
        </div>

        <div>
          <h2 className="text-lg font-medium">Transfer Of Data</h2>

          Your information, including Personal Data, may be transferred to —
          and maintained on — computers located outside of your state,
          province, country or other governmental jurisdiction where the data
          protection laws may differ from those of your jurisdiction.

          {"\n\n"}
          If you are located outside Ukraine and choose to provide information
          to us, please note that we transfer the data, including Personal
          Data, to Ukraine and process it there.

          {"\n\n"}
          Your consent to this Privacy Policy followed by your submission of
          such information represents your agreement to that transfer.

          {"\n\n"}
          {TaxiServiceName} will take all steps reasonably necessary to ensure
          that your data is treated securely and in accordance with this Privacy
          Policy and no transfer of your Personal Data will take place to an
          organization or a country unless there are adequate controls in place,
          including the security of your data and other personal information.
        </div>

        <div>
          <h2 className="text-lg font-medium">Disclosure Of Data</h2>

          Legal Requirements

          {"\n\n"}
          {TaxiServiceName} may disclose your Personal Data in the good faith
          belief that such action is necessary to:
          {"\n"}
          - To comply with a legal obligation
          {"\n"}
          - To protect and defend the rights or property of {TaxiServiceName}
          {"\n"}
          - To prevent or investigate possible wrongdoing in connection with the
          Service
          {"\n"}
          - To protect the personal safety of users of the Service or the public
          {"\n"}
          - To protect against legal liability
        </div>

        <div>
          <h2 className="text-lg font-medium">Security Of Data</h2>

          The security of your data is important to us, but remember that no
          method of transmission over the Internet or method of electronic
          storage is 100% secure. While we strive to use commercially
          acceptable means to protect your Personal Data, we cannot guarantee
          its absolute security.
        </div>

        <div>
          <h2 className="text-lg font-medium">Service Providers</h2>

          We may employ third-party companies and individuals to facilitate our
          Service, provide the Service on our behalf, perform Service-related
          services, or assist us in analyzing how our Service is used.

          {"\n\n"}
          These third parties have access to your Personal Data only to perform
          these tasks on our behalf and are obligated not to disclose or use it
          for any other purpose.
        </div>

        <div>
          <h2 className="text-lg font-medium">Links To Other Sites</h2>

          Our Service may contain links to other sites that are not operated by
          us. If you click on a third-party link, you will be directed to that
          third-party's site. We strongly advise you to review the Privacy
          Policy of every site you visit.

          {"\n\n"}
          We have no control over and assume no responsibility for the content,
          privacy policies, or practices of any third-party sites or services.
        </div>

        <div>
          <h2 className="text-lg font-medium">Children's Privacy</h2>

          Our Service does not address anyone under the age of 18 ("Children").

          {"\n\n"}
          We do not knowingly collect personally identifiable information from
          anyone under the age of 18. If you are a parent or guardian and you
          are aware that your child has provided us with Personal Data, please
          contact us. If we become aware that we have collected Personal Data
          from children without verification of parental consent, we take steps
          to remove that information from our servers.
        </div>

        <div>
          <h2 className="text-lg font-medium">
            Account and Data Deletion
          </h2>

          The App does not provide a feature to delete user accounts.

          {"\n\n"}
          If you wish to request the deletion of your personal data, you may
          contact us using the email address provided below.

          {"\n\n"}
          We will review each request and delete personal data where possible.
          Certain information may be retained if required to comply with legal
          obligations, resolve disputes, prevent fraud, enforce our agreements,
          or satisfy legitimate business purposes.

          {"\n\n"}
          If data cannot be deleted immediately for these reasons, it will be
          retained only for as long as necessary and securely deleted
          thereafter.
        </div>

        <div>
          <h2 className="text-lg font-medium">Changes To This Privacy Policy</h2>

          We may update our Privacy Policy from time to time. We will notify
          you of any changes by posting the new Privacy Policy on this page.

          {"\n\n"}
          We will let you know via email and/or a prominent notice on our
          Service prior to the change becoming effective and update the
          "Effective date" at the top of this Privacy Policy.

          {"\n\n"}
          You are advised to review this Privacy Policy periodically for any
          changes. Changes to this Privacy Policy are effective when they are
          posted on this page.
        </div>

        <div style={{ marginBottom: 50 }}>
          <h2 className="text-lg font-medium">Contact Us</h2>

          <p>
            If you have any questions about this Privacy Policy or would like to
            request deletion of your personal data, please contact us:
          </p>

          <p>
            By email:{" "}
            <a
              href={`mailto:${TaxiServiceEmail}`}
              className="text-blue-600 hover:underline"
            >
              {TaxiServiceEmail}
            </a>
          </p>
        </div>
      </section>
    </div>
  );
}